const ProductMaterialsView = ({ allMaterials, product }) => {
  const materials = product.materials || [];

  const productMaterials = materials.map((i) => ({
    ...i,
    name:
      allMaterials.find((m) => m.id === `${i.materialId}`)?.name || "Unknown",
  }));

  const percentage = (weight) => (weight / product.weight) * 100;

  return (
    <div>
      <table>
        <tbody className="divide-y divide-gray-100 dark:divide-gray-700">
          {productMaterials.map((material, index) => (
            <tr key={index}>
              <td className="pl-0 whitespace-nowrap">
                {percentage(material.weight).toFixed(2)}%
              </td>
              <td className="w-full">
                {material.name} &times; {material.weight}g
                {material.remark ? (
                  <span className="opacity-70 pl-2">
                    (Remark: {material.remark})
                  </span>
                ) : null}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProductMaterialsView;
